import { Trash2 } from 'lucide-react';
import PageWithTable from '../Common/components/PageWithTable';
import ServerHealthTable from './ServerHealthTable';
import { authenticatedApi } from '../services/api';
import { toast } from 'sonner';
import { Button } from '@/src/shadComponents/ui/button';

export default function SystemHealth() {
    const clearTempDirectoryImages = async () => {
        toast.loading('Clearing temp directory images...');

        let results = await authenticatedApi.get(
            '/telemetry/clear-temp-directory-images',
        );

        if (results.status === 200) {
            toast.success('Temp directory images cleared');
        } else {
            toast.error('Failed to clear temp directory images');
        }
    };
    const actions = (
        <Button
            variant="destructive"
            onClick={clearTempDirectoryImages}
        >
            <Trash2 className="h-4 w-4" aria-hidden="true" />
            Delete Temp Images
        </Button>
    );
    return (
        <PageWithTable title="System Health" actions={actions} breadcrumbs={[{ label: 'Admin' }, { label: 'System Health' }]}>
            <ServerHealthTable />
        </PageWithTable>
    );
}
